import React from 'react';
import "../styleFiles/Projects.css";

const Projects = () => {
  const projectsData = {
    realTime: [
      {
        title: "🏗️ Elesraa For Aluminum Products",
        image: "assets/ProjectsPosters/Elesraa.png",
        description: "🌐 Project Overview: A full-featured, bilingual (Arabic) website for a real aluminum services company in Egypt, built to showcase products and manage business operations efficiently.",
        features: [
          "Product Categories Display",
          "Dynamic Photo Gallery",
          "Customer Reviews",
          "Arabic RTL Layout",
          "Responsive Design"
        ],
        tech: ["JS", "Bootstrap", "Flask", "Vercel", "Github", "PostgreSQL", "Neon"],
        liveLink: "https://elesraa-for-aluminum-products.vercel.app/"
      },
      {
        title: "🏗️ Elesraa Admin Dashboard",
        image: "assets/ProjectsPosters/ElesraaDashboard.png",
        description: "🌐 A secure, responsive admin dashboard designed to help the business owner efficiently manage and control all aspects of the aluminum services website in real time.",
        features: [
          "Gallery Management",
          "Reviews Management",
          "Booking Management",
          "FAQs Management"
        ],
        tech: ["JS", "Bootstrap", "Flask", "Vercel", "Github", "PostgreSQL", "Neon"],
        liveLink: "https://elesraa-for-aluminum-products.vercel.app/signIn"
      },
      {
        title: "🏢 Jannaty Support Services",
        image: "assets/ProjectsPosters/Jannaty.png",
        description: "🌐 A clean, responsive website built for a real estate support services company, designed to showcase offerings and simplify user interaction.",
        features: [
          "Displays the full range of support services provided by Jannaty",
          "Visual Gallery",
          "Dynamic Admissions Form",
          "Dynamic Job Listings",
          "Online Job Applications",
          "Display Events",
          "Display Blogs",
          "Display Courses",
          "Display Calendar Events",
          "Responsive Design"
        ],
        tech: ["JS", "Bootstrap", "Flask", "Hostinger", "Github", "PostgreSQL"],
        liveLink: "https://jannatysupportservices.org"
      },
      {
        title: "🏢 Jannaty Admin Dashboard",
        image: "assets/ProjectsPosters/JannatyDashboard.png",
        description: "🌐 A secure admin dashboard built to manage the operations of the Jannaty Support Services platform efficiently. It provides powerful tools to handle job listings, review applications, and prepare for future service management.",
        features: [
          "Services Management",
          "Gallery Management",
          "Jobs Management",
          "Applications Management",
          "Admissions Management",
          "Events Management",
          "Blogs Management",
          "Courses Management",
          "Calendar Events Management",
          "Responsive Design"
        ],
        tech: ["JS", "Bootstrap", "Flask", "Hostinger", "Github", "PostgreSQL"],
        liveLink: "https://jannatysupportservices.org/Login"
      },
      {
        title: "💼 My Portfolio Website",
        image: "assets/ProjectsPosters/Profile.png",
        description: "🌐 A responsive, bilingual (English) portfolio website that showcases my background as a Software Engineer, Full Stack Developer, and AI Enthusiast. Built to present my real-world projects, technical skills, and professional journey in a structured, elegant interface.",
        features: [
          "About Me Section",
          "Projects Gallery",
          "Skills Overview",
          "Education & Certifications",
          "Contact Section",
          "Fully Responsive Design"
        ],
        tech: ["JS", "Bootstrap", "React", "Github", "Vercel"],
        liveLink: "/"
      },
      {
        title: " Elkhayal SW Development Website",
        image: "assets/ProjectsPosters/Elkhayal.png",
        description: "🌐 A modern, professional website built for Elkhayal Software Company, a startup co-founded by Ahmed Osama Fawzy. The site serves as a digital front for the company’s mission, services, team, and projects.",
        features: ["🚧 Will be Coming Soon !!!!"],
        tech: ["JS", "Bootstrap", "React", "Flask", "JWT", "Vercel", "Github"],
        liveLink: "https://elkhayal-sw-development.vercel.app/"
      },
      {
        title: "🎓 Graduation Project – SumGenQ",
        image: "assets/ProjectsPosters/SumGenQ.jpg",
        description: "🌐 SumGenQ is an AI-powered platform designed to generate intelligent summaries from long-form text, documents, or images — built as a graduation project by Ahmed Osama Fawzy and his team.",
        features: ["Text Summary", "Book Summary", "Chatbot QA", "Quiz Generator", "TTS System", "History System"],
        tech: ["Flask", "PostgreSQL", "JWT", "Vercel", "Github", "Neon"],
        liveLink: "/",
        badge: "I Just Made the Logic & DB Connections"
      },
      {
        title: "🛠️ Elesraa Agenda System",
        image: "assets/ProjectsPosters/Agende.png",
        description: "🌐 The first-ever solution built for Elesraa Aluminum Products to streamline component management. As the first step in Elesraa’s digital evolution journey, Agenda drastically reduces tasks that used to take over 5 hours to just a few minutes. The system is bilingual (Arabic & English) and includes full data analysis for all components. Built with Flask and integrated with Cloudinary, it features responsive modals, forms, and interactive maps using Leaflet.",
        features: [
            "Dynamic list of indexed components",
            "Add/Edit/Delete components with confirmation modals",
            "Forms for component details",
            "Media upload & management via Cloudinary",
            "Interactive maps using Leaflet",
            "Real-time frontend updates",
            "Responsive design for all devices",
            "Dramatically reduces task completion time",
            "First digital solution for this workflow at Elesraa",
            "Bilingual (Arabic & English)",
            "Data analysis for all components"
        ],
        tech: ["JS", "Bootstrap", "Flask", "PostgreSQL", "Cloudinary", "Leaflet", "Github", "Vercel", "Neon"],
        liveLink: "https://elesraa-lite-erp.vercel.app/"
      },
      {
        title: "🤖 Radionaly AI Hackathon Project",
        image: "assets/ProjectsPosters/Radionaly.png",
        description: "🌐 Radionaly is an AI-powered project developed during a hackathon. It demonstrates rapid prototyping and application of AI models to solve real-world problems. The system leverages machine learning and natural language processing to provide intelligent insights and automation.",
        features: [
            "AI-driven analytics and decision support",
            "Rapid data processing and predictions",
            "User-friendly interface for easy interaction",
            "Real-time results and feedback",
            "Integration with external APIs",
            "Fully responsive design",
            "Hackathon MVP built under tight deadlines"
        ],
        tech: ["Python", "Flask", "React", "Axios", "JWT", "Machine Learning", "NLP", "Bootstrap", "Github", "PostgreSQL", "Vercel", "Neon"],
        liveLink: "https://hackathon-wine-delta.vercel.app/"
      }

    ],
    demo: [
      {
        title: "✈ Flight Reservation System Website",
        image: "assets/ProjectsPosters/placeholder.png",
        description: "🌐 A complete web-based system designed to simulate a real-world flight booking platform, where users can browse available flights, reserve tickets, and manage their reservations.",
        features: ["Flight Search & Browsing", "Flight Details Display", "Booking Functionality", "Booking Management", "Admin Dashboard"],
        tech: ["HTML", "CSS", "JS", "Flask", "SQLite", "Github"],
        liveLink: "https://github.com/Ahmed-Osama-Fawzy/Flight-System-Website"
      },
      {
        title: "📖 Library Management System Website",
        image: "assets/ProjectsPosters/placeholder.png",
        description: "🌐 A full-featured web application designed to manage book borrowing and tracking in a digital library environment.",
        features: ["Search & Browse Books", "Book Borrowing Requests", "Personal Dashboard", "Admin Dashboard", "Book Inventory Management"],
        tech: ["HTML", "CSS", "JS", "TS", "Bootstrap", "SASS", "PUG.JS", "Github"],
        liveLink: "https://www.linkedin.com/posts/ahmed-osama-289bb0288_librarysystem-webdevelopment-responsivedesign-activity-7173143508558430208-HvSD"
      },
      {
        title: "📖 Library Management App Website",
        image: "assets/ProjectsPosters/placeholder.png",
        description: "🌐 A full-featured web application designed to manage book borrowing and tracking in a digital library environment.",
        features: ["Catalog Management", "Member Management", "Loan Management", "Search Functionality"],
        tech: ["JS", "ES6", "Django", "SQLite", "Github"],
        liveLink: "https://www.linkedin.com/posts/ahmed-osama-289bb0288_libraryapp-opensource-fullstackdevelopment-activity-7211286727041118208-3QBI"
      },
      {
        title: "👨🏻‍💼 HR Management System Website",
        image: "assets/ProjectsPosters/placeholder.png",
        description: "🌐 A comprehensive HR management system built as a web application to streamline employee hiring, job postings, and application tracking.",
        features: ["Job Listings Management", "Online Application Form", "Vacations Management", "Status Updates", "Admin HR Dashboard"],
        tech: ["JS", "ES6", "Django", "SQLite", "Github"],
        liveLink: "https://github.com/Ahmed-Osama-Fawzy/Human-Resources-Website/tree/main/Django%20Version/HumanResourses"
      },
      {
        title: "👨🏻‍💼 Toffee Store Website",
        image: "assets/ProjectsPosters/placeholder.png",
        description: "🌐 Toffee Store is an elegant, responsive e-commerce-style website created for a sweets and desserts business.",
        features: ["Product Display", "Visual Gallery", "Contact & Order Section", "Product Management", "Order Tracking Dashboard", "Admin Dashboard"],
        tech: ["JS", "ES6", "Flask", "SQLite", "Github"],
        liveLink: "https://github.com/Ahmed-Osama-Fawzy/Toffee-Store-Website"
      },
      {
        title: "🏧 Mini Bank System - Desktop App",
        image: "assets/ProjectsPosters/placeholder.png",
        description: "🌐 The Mini Bank System is a simplified online banking platform that simulates core banking functionalities for learning, testing, or small-scale deployment purposes.",
        features: ["Account Creation & Login", "Balance Overview", "Money Transfers", "Transaction History", "Customer Dashboard", "Customer Profile"],
        tech: ["Console App", "C++", "SQLite", "OOP", "Github"],
        liveLink: "https://github.com/Ahmed-Osama-Fawzy/Mini-Bank-System"
      },
      {
        title: "⚙️ Java Scheduling CPU - Console App",
        image: "assets/ProjectsPosters/placeholder.png",
        description: "🌐 A console app that simulates CPU scheduling algorithms for educational purposes.",
        features: ["Algorithm Support: FCFS", "Algorithm Support: SJF", "Algorithm Support: Priority Scheduling", "Algorithm Support: Round Robin"],
        tech: ["Console App", "Java", "OOP", "Github"],
        liveLink: "https://github.com/Ahmed-Osama-Fawzy/Java-Scheduling-CPU"
      }
    ]
  };

  const renderCarouselItems = (projects) =>
    projects.map((proj, index) => (
      <div className={`carousel-item ${index === 0 ? "active" : ""}`} key={index}>
        <section className="row row-cols-1">
          <div className="col project-image" style={{ backgroundImage: `url('${proj.image}')` }}></div>
          <div className="col">
            <h5>{proj.title}</h5>
            <span className="m-2 fs-6">{proj.description}</span>
            {proj.badge && <span className="badge text-bg-info"> {proj.badge} </span>}
            <ul className="m-1">
              {proj.features.map((f, i) => (
                <li key={i}>{f}</li>
              ))}
            </ul>
            <a className="DarkButton" href={proj.liveLink} target="_blank" rel="noreferrer">
              <i className="fa-solid fa-eye"></i> {proj.liveLink.includes("github") ? "Code Repo" : "Live Demo"}
            </a>
            {proj.tech.map((t, i) => (
              <button key={i} className="LightButton">
                <i className="fa-solid fa-link"></i> {t}
              </button>
            ))}
          </div>
        </section>
      </div>
    ));

  return (
    <>
      <section>
        <h1 className="component-title"> Real-Time Projects </h1>
        <div id="carouselExampleRide" class="carousel slide" data-bs-ride="true">
          <div className="carousel-inner">{renderCarouselItems(projectsData.realTime)}</div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleRide" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleRide" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
          </button>
        </div>

        <h1 className="component-title"> Demo Projects </h1>
        <div id="carouselExampleRide2" class="carousel slide" data-bs-ride="true">
          <div className="carousel-inner">{renderCarouselItems(projectsData.demo)}</div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleRide2" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleRide2" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
          </button>
        </div>
      </section>
    </>
  );
};

export default Projects;
